import React from 'react';

import * as S from './styles';

const Slide5: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Content>
        <S.SubtitleMobile>
          Jaqueta, B.Luxo, R$ 1.580. Top, collab Bold Strap + Marcelo Bonito, R$
          2.900.
          <br />
          Legging, Bold Strap, R$ 439.
        </S.SubtitleMobile>
      </S.Content>
    </S.Container>
  );
};

export { Slide5 };
